import MergeIcon from "@mui/icons-material/CallMerge";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FileCopyIcon from "@mui/icons-material/FileCopyOutlined";
import LinkIcon from "@mui/icons-material/Link";
import ModeEditOutlineOutlinedIcon from "@mui/icons-material/ModeEditOutlineOutlined";
import MoreVertOutlinedIcon from "@mui/icons-material/MoreVertOutlined";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import {
    Avatar,
    Box,
    IconButton,
    Menu,
    MenuItem,
    Tooltip,
} from "@mui/material";
import React, { memo, useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import teamsIcon from "../../../assest/emojis/teams.svg";
import whatsappIcon from "../../../assest/emojis/whatsapp-icon.svg";
import { connect } from "react-redux";
import { IState } from "../../../redux/reducers/rootReducers";
import { ITicket } from "../../../redux/actions/TicketsManagement/TicketsManagement";
import { Link } from "react-router-dom";
import UpdateOutlinedIcon from '@mui/icons-material/UpdateOutlined';
import AccessAlarmOutlinedIcon from '@mui/icons-material/AccessAlarmOutlined';

interface TicketActionProps {
    ticketData: ITicket;
    rolesAccess?: Record<string, any>;
    dispatch?: any;
    parentId?: string | number;
}

const TicketActionsNew = memo((props: TicketActionProps) => {
    const {
        ticketData,
        rolesAccess,
        dispatch,
        parentId
    } = props;
    const { contacts } = ticketData?.ticketLogs || {};
    const [isShow, setIsShow] = useState<boolean>(false);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const navigate = useNavigate();

    /* ======== ACTION HANDLERS ========= */
    const openView = () => {
        if (ticketData?.id) {
            dispatch({
                type: "TICKET_VIEW_INFO",
                payload: { ticketId: ticketData.id, type: "quick-update" },
            });
        }
    }
    const onOpenWhatsAppModel = () => {
        dispatch({
            type: "WHATSAPP_POPUP_INFO",
            payload: ticketData,
        });
    };

    const handleMerge = useCallback((ticketData: any, type: string) => {
        dispatch({
            type: "LINK_MERGE_POPUP_INFO",
            payload: { ticketData, type, parentId },
        });
    }, [ticketData]);
    
    const onQuickUpdate = useCallback(() => {
        dispatch({
            type: "ADD_UPDATE_POPUP_INFO",
            payload: { ...ticketData, type: "quick-update" }
        });
    }, [ticketData]);

    const handleClose = () => setAnchorEl(null);

    const handleMore = useCallback((event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    }, [setAnchorEl]);

    const handleClone = () => {
        navigate(`/home/ticket/${ticketData.id}?clone=true`);
    };
    /* ======== END ACTION HANDLERS ========= */

    const actionInfo = rolesAccess?.[ticketData?.ticketLogs?.ticketTypeId || "-1"] || {};
    const isSuperAdmin = rolesAccess?.isSuperAdmin || false;
    return (
        <Box className="ticketActionsNew">
            <Box className={"row m-0 p-0"}>
                {(rolesAccess?.isSuperAdmin || actionInfo?.Update) && (
                    <IconButton
                        className="actionicon"
                        aria-label="Quick Update"
                        onClick={onQuickUpdate}
                    >
                        <Tooltip title="Quick Update">
                            <UpdateOutlinedIcon />
                        </Tooltip>
                    </IconButton>
                )}
                {(rolesAccess?.isSuperAdmin || actionInfo?.Timeline) && (
                    <Link to={`/history/${ticketData?.id}`}>
                        <IconButton
                            className="actionicon"
                            aria-label="TimeLine"
                        >
                            <Tooltip title="TimeLine">
                                <AccessAlarmOutlinedIcon />
                            </Tooltip>
                        </IconButton>
                    </Link>
                )}
                {(isSuperAdmin || actionInfo?.View) && (
                    <Tooltip title="View">
                        <Link to={`/ticketInfoView/${ticketData?.id}`}>
                            <IconButton
                                className="actionicon"
                                aria-label="View"
                            >
                                <RemoveRedEyeOutlinedIcon />
                            </IconButton>
                        </Link>
                    </Tooltip>
                )}
                {(isSuperAdmin || actionInfo?.Edit) && (
                    <Tooltip title="Edit">
                        <Link to={`/home/ticket/${ticketData?.id}`}>
                        <IconButton
                            className="actionicon"
                            aria-label="Edit"
                        >
                            <ModeEditOutlineOutlinedIcon />
                        </IconButton>
                        </Link>
                    </Tooltip>
                )}
                {(ticketData?.ticketRelationshipList?.length || 0) > 0 && (
                    <Tooltip title="Child">
                        <IconButton
                            className="actionicon"

                            aria-label="Child"
                            onClick={() => setIsShow(!isShow)}
                        >
                            {isShow ? <ExpandMoreIcon /> : <ExpandLessIcon />}
                        </IconButton>
                    </Tooltip>
                )}
                {contacts?.teamsId && (
                    <Tooltip title="Teams">
                        <IconButton
                            className="actionicon" aria-label="Teams">
                            <a
                                href={`https://teams.microsoft.com/l/chat/0/0?users=${contacts?.teamsId}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                style={{ display: "flex" }}
                            >
                                <Avatar sx={{ width: 20, height: 20 }} alt="teams" src={teamsIcon} />
                            </a>
                        </IconButton>
                    </Tooltip>
                )}
                {contacts?.whatsAppNumber &&
                    <Tooltip title="WhatsApp">
                        <IconButton
                            className="actionicon" aria-label="Whatsapp">
                            <Avatar
                                sx={{ width: 20, height: 20 }}
                                alt="whatsapp"
                                src={whatsappIcon}
                                onClick={onOpenWhatsAppModel}
                                style={{ cursor: "pointer" }}
                            />
                        </IconButton>
                    </Tooltip>
                }
                {(isSuperAdmin || actionInfo?.Merge || actionInfo?.Link || actionInfo?.Split) && (
                    <Tooltip title="More">
                        <IconButton
                            className="actionicon"

                            onClick={handleMore}
                            aria-label="More"
                        >
                            <MoreVertOutlinedIcon />
                        </IconButton>
                    </Tooltip>
                )}
            </Box>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    "aria-labelledby": "basic-button",
                }}
            >
                {(isSuperAdmin || actionInfo?.Merge) && (
                    <MenuItem
                        onClick={() => {
                            handleMerge(ticketData, "merge");
                            handleClose();
                        }}
                    >
                        <MergeIcon fontSize="small" /> <span style={{ marginLeft: 10 }}>Merge</span>
                    </MenuItem>
                )}
                {(isSuperAdmin || actionInfo?.Link) && (
                    <MenuItem
                        onClick={() => {
                            handleMerge(ticketData, "link");
                            handleClose();
                        }}
                    >
                        <LinkIcon fontSize="small" /> <span style={{ marginLeft: 10 }}>Link</span>
                    </MenuItem>
                )}
                {(isSuperAdmin || actionInfo?.Split) && (
                    <MenuItem onClick={handleClone}>
                        <FileCopyIcon fontSize="small" /> <span style={{ marginLeft: 10 }}>Clone</span>
                    </MenuItem>
                )}
            </Menu>
        </Box>
    );
});
// export default TicketActionsNew;
const mapStateToProps = (state: IState) => {
    return ({
        LoginReducer: state?.LoginReducer?.roleAccess,
        rolesAccess: state?.LoginReducer?.roleAgentAccess?.ticketTypeAccess
    })
};

export default connect(mapStateToProps)(TicketActionsNew);